export const createFormData = () => ({
  inputData: {
    type: 2,
    project_id: null,
    customer_id: null,
    form_name: "",
    ref_document_no: "",
    list_details: [
      {
        name: "",
      },
    ],
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "installation_commissioning_list_masters",
    whereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/commissioning-list" };

  const headerName = "Commissioning";

  const validationType = "CommissioningCreate";
  const createEndpoint = "/createCommissioning";
  const updateEndpoint = "/updateCommissioning";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};
